import { IStep2Form } from './steps/Step2/formInterface';
import { IStep4Form } from './steps/Step4/formInterface';
import { IStep1Form } from './steps/Step1/formInterface';
import { IStep5Form } from './steps/Step5/formInterface';
import { IStep6Form } from './steps/Step6/formInterfaces';
import { IStep7Form } from './steps/Step7/formInterfaces';
import { ILocationItem, IStep3Form } from './steps/Step3/formInterfaces';

// Each step's blank state is exported twice, on purpose:
//
//   makeStaticValuesForStepN()  — a factory returning a FRESH object every call.
//   staticValuesForStepN        — a module-level constant, derived from that factory.
//
// The factory is what the flow containers must use for `useState` initializers and
// for "start over" resets. `setStepN(staticValuesForStepN)` re-assigns the *same*
// reference, so React's eager bail-out means no dependency changes — and the
// containers' only `putSteps` caller is an effect keyed on the step values. After
// `dropStepper()` has emptied the published steps, that effect never re-fires and
// the stepper stays blank permanently (D-24094 §13). A new top-level identity is
// what makes it re-publish; the fresh nested objects are defensive freshness.
//
// The constants stay for callers that only read a default *value* (never store it
// as state), so nothing outside this file had to change.

const makeStep3ItemLocation = (): ILocationItem => ({
  isShowState: true,
  country: 'US',
  state: null,
  province: null,
  address1: null,
  address2: null,
  city: null,
  zip: null
});

export const cloudfrontImagesBaseURL: string = 'https://dg6qn11ynnp6a.cloudfront.net/classifieds/images/';

export const step3ItemLocation: ILocationItem = makeStep3ItemLocation();

export const makeStaticValuesForStep1 = (): IStep1Form => ({
  listingType: 2 // Default to Featured (the most-visible listing) on a fresh load
});
export const staticValuesForStep1: IStep1Form = makeStaticValuesForStep1();

export const makeStaticValuesForStep2 = (): IStep2Form => ({
  jobTitle: null,
  companyName: null,
  employmentTypeId: 1, // default to Full Time
  industrySectorId: 0,
  supplierId: null,
  supplierTitle: null
});
export const staticValuesForStep2: IStep2Form = makeStaticValuesForStep2();

export const makeStaticValueForStep3 = (): IStep3Form => ({
  salaryMax: null,
  salaryMin: null,
  salaryUnitId: 5,
  salaryExact: null,
  locations: [makeStep3ItemLocation()],
  noneLocation: false,
  salaryUnitRadio: 2,
});
export const staticValueForStep3: IStep3Form = makeStaticValueForStep3();

export const makeStaticValuesForStep4 = (): IStep4Form => ({
  shortDescription: null,
  jobDescription: ''
});
export const staticValuesForStep4: IStep4Form = makeStaticValuesForStep4();

export const makeStaticValuesForStep5 = (): IStep5Form => ({
  uploadedLogoPath: null,
});
export const staticValuesForStep5: IStep5Form = makeStaticValuesForStep5();

export const makeStaticValuesForStep6 = (): IStep6Form => ({
  email: null,
  applicationEmail: '',
  contactLastName: null,
  contactFirstName: null,
  applicationUrl: null,
  showEmails: true,
  applicationUrlEnabled: false,
  tempAdditionalEmails: [
    {
      email: null
    }
  ]
});
export const staticValuesForStep6: IStep6Form = makeStaticValuesForStep6();

export const makeStaticValuesForStep7 = (): IStep7Form => ({
  stripePaymentMethodId: '',
  billingCountry: 'US',
  billingEmail: '',
  billingAddress1: '',
  billingCity: '',
  billingProvince: '',
  billingZip: '',
  billingCompany: '',
  billingPhone: '',
  billingFirstName: '',
  billingLastName: ''
});
export const staticValuesForStep7: IStep7Form = makeStaticValuesForStep7();
